import { ContentLoader, DatePicker } from "@rio-cloud/rio-uikit";
import moment, { Moment } from "moment";
import { ErrorsType } from "../index";
import { Custom } from "./Custom";
import { formatPhoneNumber } from "../../../../../utils/phoneUtils";
import { IOccurrenceVehicleData } from "../../../../../api/fetchOccurence";
import MainOccurenceCard from "../../../components/MainOcurrenceCard";
interface Props {
    responsible: string;
    handleResponsible: (value: string) => void;
    dn: string;
    handleDn: (value: string) => void;
    chassis: string;
    handleChassis: (value: string) => void;
    licensePlate: string;
    handleLicensePlate: (value: string) => void;
    customer: string;
    handleCustomer: (value: string) => void;
    dnResponsible: string;
    handleDnResponsible: (value: string) => void;
    hourMeter: number;
    handleHourMeter: (value: number) => void;
    odometer: number;
    handleOdometer: (value: number) => void;
    entryDate: string;
    handleEntryDate: (value: string) => void;
    isLoading: boolean;
    errors: ErrorsType;
    optionsRegionals: any;
    selectedRegional?: string[];
    handleChangeRegional: (id?: string) => void;
    phone: string;
    handlePhone: (phone: string) => void;
    subject?: string;
    occurrenceVehicleData?: IOccurrenceVehicleData;
    onClearOcurrence:  () => void;
    enableClear: boolean;
    showVinculateOccurrence: boolean;
}

type InputType = {
    label: string;
    value?: string;
    onChange?: (value: string) => void;
    isLoading: boolean;
    error?: boolean;
    placeholder?: string;
    minLength?: number;
    maxLenght?: number;
    disabled?: boolean;
};

const Input = ({
    label,
    value,
    onChange,
    isLoading,
    error,
    placeholder,
    minLength,
    maxLenght,
    disabled,
}: InputType) => {
    return (
        <div className="form-group form-group-lg width-100pct">
            <label htmlFor={label}>{label}</label>
            {isLoading ? (
                <div style={{ height: 45, borderRadius: 8, overflow: "hidden" }}>
                    <ContentLoader className="width-100pct height-100pct" />
                </div>
            ) : (
                <>
                    <input
                        id={label}
                        className="form-control"
                        type="text"
                        minLength={minLength}
                        maxLength={maxLenght}
                        placeholder={placeholder}
                        value={value}
                        onChange={(evt) => onChange?.(evt.target.value)}
                        disabled={disabled}
                    />
                    <div className="height-15">
                        {error ? (
                            <span className="text-size-12 text-color-danger">
                                {minLength && value && value?.length < minLength ? 'Campo inválido' : 'Campo obrigatório'}
                            </span>
                        ) : null}
                    </div>
                </>
            )}
        </div>
    );
};

const Occurrence = ({
    responsible,
    handleResponsible,
    dn,
    handleDn,
    chassis,
    handleChassis,
    licensePlate,
    handleLicensePlate,
    customer,
    handleCustomer,
    dnResponsible,
    handleDnResponsible,
    hourMeter,
    handleHourMeter,
    odometer,
    handleOdometer,
    entryDate,
    handleEntryDate,
    isLoading,
    errors,
    optionsRegionals,
    selectedRegional,
    handleChangeRegional,
    handlePhone,
    phone,
    subject,
    occurrenceVehicleData,
    onClearOcurrence,
    enableClear,
    showVinculateOccurrence
}: Props) => {
    const isRequiredForType = subject === "TECHNICAL";

    return (
        <div className="width-100pct height-100pct border rounded padding-15">
            {showVinculateOccurrence ? <>
                <div className="margin-bottom-15">
                    <span className="text-size-14 text-color-dark">
                        Vincular a uma ocorrência
                    </span>
                </div>

                {occurrenceVehicleData ? (
                    <MainOccurenceCard occurrenceVehicleData={occurrenceVehicleData} onClear={enableClear ? null : onClearOcurrence} />
                ) : null}
            </> : null}

            <div className="width-100pct" style={{ display: "flex", gap: 20 }}>
                <Input
                    label="Responsável*"
                    value={responsible}
                    onChange={handleResponsible}
                    isLoading={isLoading}
                    // error={errors.responsible}
                    placeholder="Obrigatório"
                    disabled
                />
                <Input
                    label="Dn*"
                    value={dn}
                    onChange={handleDn}
                    isLoading={isLoading}
                    // error={errors.dn}
                    placeholder="Obrigatório"
                    disabled
                />
                <Input
                    label={isRequiredForType ? "Chassi do veículo*" : "Chassi do veículo"}
                    value={chassis}
                    onChange={handleChassis}
                    isLoading={isLoading}
                    error={errors.chassis}
                    placeholder={isRequiredForType ? "Obrigatório" : 'Opcional'}
                    minLength={17}
                    maxLenght={17}
                    // disabled
                />
                <Input
                    label={isRequiredForType ? "Placa do veículo*" : "Placa do veículo"}
                    value={licensePlate}
                    onChange={handleLicensePlate}
                    isLoading={isLoading}
                    // error={errors.licensePlate}
                    placeholder={isRequiredForType ? "Obrigatório" : 'Opcional'}
                    disabled
                />
            </div>
            <div className="width-100pct" style={{ display: "flex", gap: 20 }}>
                <Input
                    label="Responsável pelo chamado no DN*"
                    value={dnResponsible}
                    onChange={handleDnResponsible}
                    isLoading={isLoading}
                    // error={errors.dnResponsible}
                    placeholder="Obrigatório"
                    disabled
                />
                <Input
                    label={"Tel para contato*"}
                    value={phone}
                    isLoading={isLoading}
                    // error={errors?.phone}
                    onChange={(e) => handlePhone(formatPhoneNumber(e))}
                    placeholder={"Obrigatório"}
                    disabled
                />
                <Input
                    label={isRequiredForType ? "Nome do cliente*" : "Nome do cliente"}
                    value={customer}
                    onChange={handleCustomer}
                    isLoading={isLoading}
                    // error={errors.customer}
                    placeholder={isRequiredForType ? "Obrigatório" : 'Opcional'}
                    disabled
                />
                <Custom.Select
                    label="Regional*"
                    options={optionsRegionals}
                    value={selectedRegional}
                    onChange={handleChangeRegional}
                    // error={errors.selectedRegional}
                    placeholder="Obrigatório"
                    isLoading={isLoading}
                    disabled
                />
            </div>
            <div className="width-100pct" style={{ display: "flex", gap: 20 }}>
                <Input
                    label={isRequiredForType ? "Horímetro*" : "Horímetro"}
                    value={hourMeter?.toString() || ""}
                    error={errors?.hourMeter}
                    placeholder={isRequiredForType ? "Obrigatório" : "Opcional"}
                    isLoading={isLoading}
                    // disabled
                    onChange={(v) => {
                        const value = Number(v);

                        if (!Number.isNaN(value)) {
                            handleHourMeter(value);
                        }
                    }}
                />

                <Input
                    label={isRequiredForType ? "Km*" : "Km"}
                    value={odometer?.toString() || ""}
                    error={errors?.odometer}
                    placeholder={isRequiredForType ? "Obrigatório" : "Opcional"}
                    isLoading={isLoading}
                    // disabled
                    onChange={(v) => {
                        const value = Number(v);

                        if (!Number.isNaN(value)) {
                            handleOdometer(value);
                        }
                    }}
                />

                <div className="form-group form-group-lg width-100pct">
                    <label htmlFor={"date"}>{isRequiredForType ? 'Data de entrada do veículo*' : 'Data de entrada do veículo'}</label>
                    {isLoading ? (
                        <div style={{ borderRadius: 8, height: 45, overflow: "hidden" }}>
                            <ContentLoader className="width-100pct height-100pct" />
                        </div>
                    ) : (
                        <>
                            <DatePicker
                                id="2"
                                inputProps={{ placeholder: "Selecione" }}
                                className="margin-bottom-0"
                                dateFormat="DD/MM/YYYY"
                                value={
                                    entryDate ? moment(entryDate).format("DD/MM/YYYY") : undefined
                                }
                                timeFormat={false}
                                onChange={(result: Moment | string) =>
                                    handleEntryDate(moment(result).format("YYYY-MM-DD"))
                                }
                                isValidDate={(currentDate: Moment) =>
                                    currentDate.isSameOrBefore(moment(), "day")
                                }
                            />
                            <div className="height-15">
                                {errors.entryDate ? (
                                    <span className="text-size-12 text-color-danger">
                                        Campo obrigatório
                                    </span>
                                ) : null}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Occurrence;
